import { toDate, toNull, toNumber, toUUID } from "shared/lib/zod/utils"
import { FloorTypename, MinimalProject } from "shared/types/Project"
import { Floor as GraphQLFloor } from "shared/types/__generated__/graphql"

import z from "zod"

export const FLOOR_LABEL_MAX_LENGTH = 90

export const FloorSchema = z.object({
  id: z.string(),
  label: z
    .string()
    .trim()
    .min(1)
    .max(FLOOR_LABEL_MAX_LENGTH)
    .optional()
    .nullish(),
  position: z.number().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  children: z.array(z.any()).optional().optional().nullish(),
  parent: z.any().optional().nullish(),
  remark: z.string().optional().nullish(),
  hasClarificationRequest: z.boolean().optional().nullish(),
  __typename: z.literal("Floor").optional()
})

export const FloorSchemaTransform = FloorSchema.extend({
  id: FloorSchema.shape.id.transform(toUUID),
  label: FloorSchema.shape.label.transform(toNull),
  createdAt: FloorSchema.shape.createdAt.transform(toDate),
  updatedAt: FloorSchema.shape.updatedAt.transform(toDate),
  children: FloorSchema.shape.children.transform(children => children ?? []),
  parent: FloorSchema.shape.parent.transform(toNull),
  position: FloorSchema.shape.parent.transform(toNumber),
  remark: FloorSchema.shape.remark.transform(toNull),
  hasClarificationRequest:
    FloorSchema.shape.hasClarificationRequest.transform(toNull),
  __typename: FloorSchema.shape.__typename.transform(() => FloorTypename)
})

export interface FloorUpdate extends Partial<GraphQLFloor> {
  id: string
}

export interface MinimalFloor {
  id: string
  label: string
  __typename?: typeof FloorTypename
}

export interface RecursiveMinimalFloorWithParent extends MinimalFloor {
  parent: MinimalProject
}
